import { MenuIcon } from "lucide-react";
import easyservice from "../../assets/easyservice.png";

import { Button } from "@/components/ui/button";
import Menu from "./menu";
import {
  Sheet,
  SheetHeader,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

export function SheetMenu() {
  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button className="h-8" variant="outline" size="icon">
          <MenuIcon size={20} />
        </Button>
      </SheetTrigger>
      <SheetContent className="sm:w-72 px-3 h-full flex flex-col" side="left">
        <SheetHeader>
          <Button
            className="flex justify-center items-center pb-2 pt-1"
            variant="link"
            asChild
          >
            <a href="/dashboard" className="flex items-center gap-2">
              <div className="flex items-center justify-center w-16 h-16 overflow-hidden">
                <img className="w-auto h-auto" src={easyservice} alt="easyservice" />
              </div>
              <h1
                className={cn(
                  'font-bold text-lg whitespace-nowrap transition-[transform,opacity,display] ease-in-out duration-300',
                  'translate-x-0 opacity-100'
                )}
              >
                EasyService
              </h1>
            </a>
          </Button>
        </SheetHeader>
        <Menu isOpen />
      </SheetContent>
    </Sheet>
  );
}
